import React, { memo } from 'react';
import isEqual from 'lodash.isequal';
import { ListingOtherSellerProps } from './types';
import ListingOtherSeller from './ListingOtherSellerRoot';

// Legacy Component (for backward compatibility)
const ListingOtherSellerMain: React.FC<ListingOtherSellerProps> = ({
  otherSellerListings,
  pageLocation,
  correlationId,
  url,
  className,
}) => {
  const { totalSellerListingsResults: total } = otherSellerListings;

  return (
    <ListingOtherSeller className={className}>
      <ListingOtherSeller.Header url={url} totalResults={total} showAlsoFromText={!!otherSellerListings.listings} />
      <ListingOtherSeller.List>
        {otherSellerListings.listings?.map(({ vipUrl, imageUrl, title, priceInfo, reserved }) => (
          <ListingOtherSeller.Item
            key={vipUrl}
            vipUrl={vipUrl}
            imageUrl={imageUrl}
            title={title || ''}
            priceInfo={priceInfo}
            reserved={reserved ?? false}
            correlationId={correlationId}
            pageLocation={pageLocation}
          />
        ))}
      </ListingOtherSeller.List>
    </ListingOtherSeller>
  );
};

// todo: find which properties are really needs to be checked for preventing rerendering
function arePropsEqual(prevProps: ListingOtherSellerProps, nextProps: ListingOtherSellerProps) {
  return isEqual(prevProps, nextProps);
}

export default memo(ListingOtherSellerMain, arePropsEqual);
